import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LeadDialogProvider } from "@/components/LeadForms";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <LeadDialogProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/owner" element={<Dashboard />} />
            </Routes>
          </LeadDialogProvider>
          <Toaster position="top-right" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
